import {Tab, Tabs} from '@mui/material';
import {useState} from 'react';
import {useLocation} from 'react-router-dom';
import NavigationActiveIcon from '@icons/NavigationActiveIcon';
import HomeButton from '../navigation-button/HomeButton';
import NetworkButton from '../navigation-button/NetworkButton';
import ServicesButton from '../navigation-button/ServicesButton';
import Header from './Header';

interface IProps {
	children: string | JSX.Element | JSX.Element[];
}

export default function Main({children}: IProps) {
	const location = useLocation();
	let path = 0;
	if (location.pathname.startsWith('/services')) {
		path = 1;
	} else if (location.pathname.startsWith('/network')) {
		path = 2;
	}
	const [tab, setTab] = useState(path);
	
	const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
		setTab(newValue);
	};
	return (
		<>
			<Header/>
			<div style={{height: 'calc(100% - 144px)'}} className="pb-2 overflow-scroll">
				{children}
			</div>
			<Tabs
				sx={{
					boxShadow: (theme) => theme.palette.mode === 'light' ? '0 -5px 5px -5px #ddd' : '0px -1px 2px 0px rgba(0, 0, 0, 0.13)',
					overflow: 'unset',
					bgcolor: 'background.default'
				}}
				className="fixed bottom-0 w-full navigation"
				value={tab}
				onChange={handleChangeTab}
				centered
				variant="fullWidth"
				TabIndicatorProps={{
					sx: {
						top: -22,
						backgroundColor: 'transparent',
						display: 'flex'
					},
					children: <NavigationActiveIcon/>
				}}>
				<Tab tabIndex={0} component={HomeButton}/>
				<Tab tabIndex={1} component={ServicesButton}/>
				<Tab tabIndex={2} component={NetworkButton}/>
			</Tabs>
		</>
	);
}
